/**
 * Shared add-to-cart helper for the 2026-09-15 black-and-white
 * homepage redesign: start-here-grid's "Add ->" links and the
 * routine-planner's per-product "Add ->" links and "Add the routine
 * ->" button. Deliberately separate from the existing
 * .minimal-product-card__atc-btn delegate in assets/theme.js (which
 * handles the pack-selector card used on collection pages) - these
 * new homepage cards have no pack selector, just a single variant id
 * baked into the link at render time.
 */
(function () {
  function openDrawer() {
    var icon = document.querySelector('.js-drawer-open-cart');
    if (icon) icon.click();
  }

  function addToCart(items, onDone) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return fetch('/cart.js');
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (c) {
          c.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(openDrawer, 200);
        if (onDone) onDone(null, cart);
      })
      .catch(function (err) {
        if (onDone) onDone(err);
      });
  }

  function withBusyState(btn, fn) {
    if (btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;
    fn(function (err) {
      btn.disabled = false;
      btn.textContent = err ? 'Error' : 'Added';
      setTimeout(function () {
        btn.textContent = original;
      }, 1500);
    });
  }

  document.addEventListener('click', function (e) {
    var single = e.target.closest('[data-bw-add]');
    if (single) {
      e.preventDefault();
      var variantId = parseInt(single.getAttribute('data-bw-add'), 10);
      if (!variantId) return;
      withBusyState(single, function (done) {
        addToCart([{ id: variantId, quantity: 1 }], done);
      });
      return;
    }

    var multi = e.target.closest('[data-bw-add-multi]');
    if (multi) {
      e.preventDefault();
      var ids;
      try {
        ids = JSON.parse(multi.getAttribute('data-bw-add-multi'));
      } catch (err) {
        return;
      }
      if (!Array.isArray(ids) || !ids.length) return;
      var items = ids.map(function (id) {
        return { id: id, quantity: 1 };
      });
      withBusyState(multi, function (done) {
        addToCart(items, done);
      });
    }
  });
})();
